<div class="reset-password">
  <div class="reset-password-form wm-view">
    <div class="wm-topbar">
      <div class="wm-topbar-header">Reset Password</div>
    </div>

    <div class="wm-card reset-password-container">
      @if (!requestFinished) {
        <div [hidden]="requesting">
          <div class="reset-password-instructions">Enter your email address and we will send you instructions to reset your password.</div>
          <div class="wm-card-content">
            <div class="form-item reset-password-email-input-container">
              <div class="form-label">
                Email
              </div>
              <input pInputText [autofocus]="true" type="email" [(ngModel)]="email" autofocus tabindex="1" data-testing-id="reset-password-passwordfield">
              @if (error) {
                <div class="reset-password-errormessage">An error occurred. Please try again.</div>
              }
            </div>
            <button pButton class="reset-password-submitbutton" [disabled]="email.trim().length === 0" (click)="submitResetPassword()" data-testing-id="reset-password-submit-button">Reset</button>
          </div>
        </div>
      }
      @if (requestFinished) {
        <div class="reset-password-success">
          <div class="success-header">
            Password reset requested
          </div>
          <div class="success-message">
            If the email address you entered is registered with us, we have sent you an email with instructions to reset your password. You can close this window now.
          </div>
        </div>
      }
      @if (requesting) {
        <div class="reset-password-spinner-wrapper">
          <p-progressSpinner></p-progressSpinner>
          <div>Requesting password reset...</div>
        </div>
      }
    </div>
  </div>
</div>
